import { each } from 'lodash';

// Toggle the beacon object into our out of view
export function beaconToggleView() {
   try {
    //@ts-ignore
    window.Beacon("toggle");
   }
   catch(e) {
    console.error(e);
   }
}

export function _getBeaconData() {
    let newSuggestionDefinition = {
        feature: undefined,
        roles: undefined,
        user_name: undefined,
        user_email: undefined,
        user_obj: undefined,
    };

    if (((typeof window !== "undefined") ? window : {})["beacon_suggestion_definition"]) {
        newSuggestionDefinition = ((typeof window !== "undefined") ? window : {})["beacon_suggestion_definition"];
    }

    return newSuggestionDefinition;
}

export function _setBeaconData(data) {
    ((typeof window !== "undefined") ? window : {})["beacon_suggestion_definition"] = data;
}

export function beaconReportUserData (user) {
    let newSuggestionDefinition = _getBeaconData();

    newSuggestionDefinition["user_name"] = user?.name;
    newSuggestionDefinition["user_email"] = user?.email;
    newSuggestionDefinition["user_obj"] = user;

    _setBeaconData(newSuggestionDefinition);
}

export function beaconReportCurrentFeature(feature) {
    let newSuggestionDefinition = _getBeaconData();

    newSuggestionDefinition["feature"] = feature;

    _setBeaconData(newSuggestionDefinition);
}

export function beaconReportCurrentRoles(roles: string[]) {
    let newSuggestionDefinition = _getBeaconData();
    
    let roleSet = "";

    each (roles, role => {
        roleSet += role + ",";
    });

    newSuggestionDefinition["roles"] = roleSet;

    _setBeaconData(newSuggestionDefinition);
}